import { render, staticRenderFns } from "./ReceivedEmailListing.vue?vue&type=template&id=0df913c9&scoped=true&"
import script from "./ReceivedEmailListing.vue?vue&type=script&lang=js&"
export * from "./ReceivedEmailListing.vue?vue&type=script&lang=js&"
import style0 from "./ReceivedEmailListing.vue?vue&type=style&index=0&id=0df913c9&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0df913c9",
  null
  
)

export default component.exports